/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyerdownload1Inputs */

const en_flyerdownload1 = /** @type {(inputs: Flyerdownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download flyer`)
};

const de_flyerdownload1 = /** @type {(inputs: Flyerdownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flyer herunterladen`)
};

/**
* | output |
* | --- |
* | "Download flyer" |
*
* @param {Flyerdownload1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerdownload1 = /** @type {((inputs?: Flyerdownload1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerdownload1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerdownload1(inputs)
	return de_flyerdownload1(inputs)
});
export { flyerdownload1 as "flyerDownload" }